import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "paddingInlineStart"];
import { Link } from 'foundations-components/transitional/components/Link';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { TeamPaddingWrapper } from '../../shared/components/TeamPaddingWrapper';
import { ROUTING_SOURCE } from '../../shared/constants/routing-source';
import { getPaidUserSettingsUrl } from '../../urls/getPaidUserSettingsUrl';
import { getUsersSeatsUrl } from '../../urls/getUsersSeatsUrl';
import { useReassignmentPaddingTokens } from '../hooks/useReassignmentPaddingTokens';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TeamOptionWrapper = _ref => {
  let {
      children,
      paddingInlineStart
    } = _ref,
    flexProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    inlineStartToken,
    otherInlineStartTokens
  } = useReassignmentPaddingTokens(paddingInlineStart);
  return /*#__PURE__*/_jsx(TFlex, Object.assign({
    "data-test-id": "reassignment-dropdown-team",
    justifyContent: "space-between",
    paddingInlineStart: inlineStartToken,
    paddingInlineEnd: "400",
    paddingBlock: "200"
  }, flexProps, {
    children: /*#__PURE__*/_jsx(TeamPaddingWrapper, {
      paddingInlineStart: otherInlineStartTokens,
      children: children
    })
  }));
};
TeamOptionWrapper.displayName = 'TeamOptionWrapper';

// TODO: move both options into a single component and extract the formatted messages & link functions based on the routing source
const TicketsTeamOption = ({
  option
}) => {
  return /*#__PURE__*/_jsxs(TeamOptionWrapper, {
    alignItems: "end",
    paddingInlineStart: option.paddingInlineStart,
    children: [option.text, option.containsFreeUsers && /*#__PURE__*/_jsx(HelpIcon, {
      alignWithText: true,
      marginInlineStart: "100",
      title: /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: 'routing-ui.users-and-teams.tooltips.team-no-service-seat-user-routing.description_jsx',
          elements: {
            Link
          },
          options: {
            external: true,
            href: getUsersSeatsUrl()
          }
        })
      })
    })]
  });
};
TicketsTeamOption.displayName = 'TicketsTeamOption';
const InboxTeamOption = ({
  option
}) => {
  return /*#__PURE__*/_jsxs(TeamOptionWrapper, {
    alignItems: "end",
    paddingInlineStart: option.paddingInlineStart,
    children: [option.text, option.containsFreeUsers && /*#__PURE__*/_jsx(HelpIcon, {
      alignWithText: true,
      marginInlineStart: "100",
      title: /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: 'routing-ui.users-and-teams.tooltips.team-free-user-routing.description_jsx',
          elements: {
            Link
          },
          options: {
            external: true,
            href: getPaidUserSettingsUrl()
          }
        })
      })
    })]
  });
};
InboxTeamOption.displayName = 'InboxTeamOption';

// TODO: move this logic & copy into conversations-routing-lib
const TeamOption = ({
  option,
  routingSource
}) => {
  const Component = routingSource === ROUTING_SOURCE.HELP_DESK ? TicketsTeamOption : InboxTeamOption;
  return /*#__PURE__*/_jsx(Component, {
    option: option
  });
};
TeamOption.displayName = 'TeamOption';
export default TeamOption;